export default function Privacy() {

return(
    <div className="flex flex-col items-center justify-center">
        <div className="w-1/2">
                Il presente documento descrive la nostra politica in merito alla raccolta e all'uso dei dati personali degli utenti di questo sito web. Garantiamo che non raccogliamo, memorizziamo o condividiamo alcuna informazione personale degli utenti.
        <br />
        <br />
                    1. Dati personali.
                    <br />
                    Questo sito web non raccoglie né tratta dati personali di alcun tipo. Non è richiesto agli utenti di fornire alcuna informazione, come nome, indirizzo email o altri dati personali, per navigare sul nostro sito.
        <br /><br />
                    2. Cookie<br />
                    Non utilizziamo cookie, né altri strumenti di tracciamento per raccogliere informazioni sull'uso del sito web. La navigazione sul nostro sito è completamente anonima.
        <br /><br />
                    3. Servizi di terze parti<br />
                    Non utilizziamo servizi di terze parti che potrebbero raccogliere informazioni personali, come strumenti di analisi, pubblicità o integrazioni di social media.
        <br /><br /><br />

        Privacy Policy per il Modulo di Contatto<br /><br />
Quali dati raccogliamo?<br />
Attraverso il modulo di contatto presente sul nostro sito, raccogliamo le seguenti informazioni:<br />

Nome e cognome<br />
Indirizzo email<br />
Numero di telefono<br />
Messaggio o richiesta inviata tramite il modulo<br /><br />
Perché raccogliamo questi dati?<br />
Le informazioni raccolte vengono utilizzate esclusivamente per:<br />

Rispondere alle richieste degli utenti.<br />
Fornire informazioni, preventivi o assistenza richiesta dagli utenti.<br /><br />
Come utilizziamo i dati?<br />
I dati forniti attraverso il modulo di contatto verranno utilizzati solo per i seguenti scopi:<br />

Comunicazione diretta con l'utente per rispondere alla richiesta.<br />
Archiviazione temporanea per garantire la gestione efficace delle richieste.<br />
Non utilizziamo le informazioni raccolte per scopi commerciali o pubblicitari senza il consenso esplicito dell'utente.<br /><br />

Condivisione dei dati<br />
Non condividiamo, vendiamo o cediamo i dati raccolti tramite il modulo di contatto a terze parti.<br /><br />

Conservazione dei dati<br />
I dati inviati tramite il modulo di contatto saranno conservati per il tempo necessario a soddisfare la richiesta dell'utente e successivamente eliminati, salvo obblighi di legge.
<br />
Come proteggiamo i dati?<br /><br />
Adottiamo tutte le misure tecniche e organizzative necessarie per proteggere i dati forniti attraverso il modulo di contatto, tra cui:<br />

Utilizzo di connessione sicura (HTTPS) per la trasmissione dei dati.<br />
Limitazione dell'accesso ai dati ai soli membri autorizzati del nostro team.<br /><br />
Diritti dell'utente<br />
Gli utenti hanno il diritto di:<br />

Accedere ai propri dati personali.<br />
Richiedere la correzione o cancellazione dei dati.<br />
Opporsi al trattamento dei propri dati per motivi legittimi.<br />
Per esercitare questi diritti, è possibile contattarci all'indirizzo email: dotserramenti@gmail.com .<br /><br />

Base legale per il trattamento dei dati<br />
Il trattamento dei dati inviati tramite il modulo di contatto si basa sul consenso esplicito dell'utente (Art. 6(1)(a) GDPR). Compilando e inviando il modulo di contatto, l'utente acconsente al trattamento dei propri dati per gli scopi specificati.
<br /><br />
Aggiornamenti alla Privacy Policy<br />
Ci riserviamo il diritto di aggiornare questa sezione in qualsiasi momento. Si consiglia di consultare periodicamente questa pagina per eventuali modifiche.<br />



        </div>
        
    </div>
    
)
}